import React, { Component } from 'react';
import { Popover, TextButton, GoogleAddressInput } from 'wix-style-react';
import clients from 'wix-style-react/dist/src/clients';
import ChevronDown from 'wix-ui-icons-common/ChevronDown';
import s from './locationFilter.scss';

class LocationFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFilterOpen: false,
      currentlyShownLocation: props.currentLocation
        ? `${props.currentLocation.city}, ${props.currentLocation.country}`
        : '',
    };
  }

  toggleFilterOpen() {
    this.setState({ isFilterOpen: !this.state.isFilterOpen });
  }

  onClickOutside() {
    if (this.state.isFilterOpen) {
      this.toggleFilterOpen();
    }
  }

  onSetLocation(value) {
    const location = parseLocation(value.address);
    this.props.onApply({ location });
    this.toggleFilterOpen();
  }

  render() {
    const { filterTitle, placeholder } = this.props;
    const { isFilterOpen, currentlyShownLocation } = this.state;

    return (
      <Popover
        animate
        appendTo="window"
        flip
        onClick={() => this.setState({ isFilterOpen: true })}
        placement="bottom"
        showArrow
        shown={isFilterOpen}
        onClickOutside={() => this.onClickOutside()}
      >
        <Popover.Element>
          <TextButton skin="dark" suffixIcon={<ChevronDown />}>
            {filterTitle}
          </TextButton>
        </Popover.Element>
        <Popover.Content>
          {this.state.isFilterOpen ? (
            <div className={s.googleAddressInputWrapper}>
              <GoogleAddressInput
                Client={clients.GoogleMapsClient}
                onSet={value => this.onSetLocation(value)}
                onChange={event =>
                  this.setState({ currentlyShownLocation: event.target.value })
                }
                value={currentlyShownLocation}
                clearSuggestionsOnBlur
                poweredByGoogle={true}
                placeholder={placeholder}
              />
            </div>
          ) : null}
        </Popover.Content>
      </Popover>
    );
  }
}

export default LocationFilter;

const parseLocation = address => ({
  city: address.city,
  country: address.country,
  state: address.state,
  lng: address.latLng.lng,
  lat: address.latLng.lat,
});
